import { validateCharacterGroveConfig } from '../minigames/character-grove/CharacterGroveConfig.js';

/** Original narrative written for the first Character Grove configuration. */
export const CHARACTER_GROVE_RESPONSE_1 = validateCharacterGroveConfig({
  id: 'character-grove-response-1',
  skillId: 'literacy-character-response-evidence',
  skillKind: 'response-to-challenge',
  title: 'Mira and the Wobbly Log',
  story: {
    id: 'mira-wobbly-log',
    title: 'Mira and the Wobbly Log',
    pages: [
      {
        id: 'creek-challenge',
        text: 'Mira the mouse carried three glowberries to the fireflies’ dusk picnic. At the creek, last night’s wind had tipped the crossing log sideways.',
      },
      {
        id: 'mira-responds',
        text: 'Mira’s paws felt shaky. “That log looks wobbly,” she whispered. She wanted to turn back, but the youngest fireflies were waiting for light.',
      },
      {
        id: 'careful-crossing',
        text: 'Mira set down her basket, took one slow breath, and tested the log with one foot. Then she crossed carefully, carrying one glowberry at a time.',
      },
      {
        id: 'mira-reflects',
        text: 'When the last glowberry shone, Mira smiled. “I was nervous, but I found a careful way to help,” she said.',
      },
    ],
  },
  character: {
    id: 'mira-mouse',
    name: 'Mira',
    description: 'A small forest mouse bringing glowberries to a dusk picnic.',
    challenge: 'The creek-crossing log is wobbly after a windy night.',
    inspectPrompt: 'Notice what Mira says, feels, and does after she sees the wobbly log.',
  },
  insightChoices: [
    {
      id: 'nervous-careful-helper',
      text: 'Mira felt nervous, but she chose a careful way to help.',
      kind: 'response-to-challenge',
    },
    {
      id: 'thought-crossing-easy',
      text: 'Mira thought the crossing was easy from the start.',
      kind: 'feeling',
    },
    {
      id: 'stopped-caring-picnic',
      text: 'Mira stopped caring about the picnic when she saw the log.',
      kind: 'motivation',
    },
  ],
  evidenceMoments: [
    {
      id: 'wind-tipped-log',
      storyPageId: 'creek-challenge',
      text: 'Last night’s wind had tipped the crossing log sideways.',
      kind: 'challenge',
    },
    {
      id: 'fireflies-waiting',
      storyPageId: 'mira-responds',
      text: 'The youngest fireflies were waiting for light.',
      kind: 'challenge',
    },
    {
      id: 'breath-test-log',
      storyPageId: 'careful-crossing',
      text: 'Mira took one slow breath and tested the log with one foot.',
      kind: 'action',
    },
    {
      id: 'one-berry-at-time',
      storyPageId: 'careful-crossing',
      text: 'She crossed carefully, carrying one glowberry at a time.',
      kind: 'action',
    },
  ],
  correctInsightId: 'nervous-careful-helper',
  supportingEvidenceIds: ['breath-test-log', 'one-berry-at-time'],
  requiredEvidenceCount: 1,
  hints: [
    {
      stage: 1,
      message: 'First, find the problem Mira faced at the creek.',
      focusEvidenceIds: ['wind-tipped-log'],
    },
    {
      stage: 2,
      message: 'Now look at what Mira did after she said the log looked wobbly.',
      focusEvidenceIds: ['breath-test-log', 'one-berry-at-time'],
    },
    {
      stage: 3,
      message: 'The strongest evidence is an action Mira took to cross carefully.',
      focusEvidenceIds: ['breath-test-log', 'one-berry-at-time'],
    },
    {
      stage: 4,
      message: 'Mira was still nervous. Which insight says she tried a careful way anyway?',
      focusInsightIds: ['nervous-careful-helper'],
    },
  ],
  completionWorldEvent: 'memory-tree-restored-1',
  successMessage: 'The memory branch grows, and Mira’s true story shines through the tree!',
});
